module.exports = __webpack_public_path__ + "static/Freight-BigLightItalic-17f54e21c84ce5fa840c46cefe595834.woff";